module.exports = __webpack_public_path__ + "assets/img/btn-detail-6d70baf1.png";